import React from 'react';
import { Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Background from '@component/Background';
const FullWidthSublayout = (props) => (
  <>
    <Background
      image={
        props.sitecoreContext.route.fields?.overridebackgroundimage?.value === false
          ? props.sitecoreContext?.sharedbackgroundimage
          : props.sitecoreContext.route.fields?.backgroundimage?.value?.src === undefined
          ? ''
          : props.sitecoreContext.route.fields?.backgroundimage?.value?.src
      }
    >
      <main>
        <Grid>
          <Row>
            <Col xs={12}>
              <Placeholder name="breadcrumb" rendering={props.rendering} />
              <Placeholder name="full-width-page-title" rendering={props.rendering} />
              <Placeholder name="full-width-sublayout" rendering={props.rendering} />
            </Col>
          </Row>
        </Grid>
      </main>
    </Background>
  </>
);

export default withSitecoreContext()(FullWidthSublayout);
